import { LoaderFunctionArgs, RouteObject } from 'react-router';

import { MobilityAccommodation } from '@/ui/pages/external/survey/mobility-accommodation/MobilityAccommodation';

import { externalLoader } from '../externalLoaders';

export const externalSurveyRoutes: RouteObject[] = [
  {
    path: 'survey-mobility-accommodation',
    loader: (args: LoaderFunctionArgs) =>
      externalLoader(args, { allowedScope: 'SURVEY-MOBILITY-ACCOMMODATION' }),
    element: <MobilityAccommodation />,
  },
];
